// Types
import type { IVDropdownOption } from '~/misc/v-dropdown/types';
import { EStockOption } from '~/misc/listings/types';

const STOCK_OPTIONS: IVDropdownOption<string, EStockOption>[] = [
  {
    label: 'All',
    value: EStockOption.ALL,
  },
  {
    label: 'Own',
    value: EStockOption.OWN,
  },
  {
    label: 'Others',
    value: EStockOption.OTHERS,
  },
];

export { STOCK_OPTIONS };
